import {
  createContext,
  useContext,
  useState,
  ReactNode,
  useMemo,
  useCallback,
} from 'react';

export interface LoadingContextType {
  isLoading: boolean;
  startLoading: () => void;
  stopLoading: () => void;
}

const LoadingContext = createContext<LoadingContextType>({
  isLoading: false,
  startLoading: () => {},
  stopLoading: () => {},
});

export const useLoading = () => useContext(LoadingContext);

export const LoadingProvider = ({ children }: { children: ReactNode }) => {
  const [loadingCount, setLoadingCount] = useState<number>(0);

  const startLoading = useCallback(() => setLoadingCount((c) => c + 1), []);

  const stopLoading = useCallback(
    () => setLoadingCount((c) => (c > 0 ? c - 1 : 0)),
    []
  );

  const value = useMemo(
    () => ({ isLoading: loadingCount > 0, startLoading, stopLoading }),
    [loadingCount, startLoading, stopLoading]
  );

  return (
    <LoadingContext.Provider value={value}>{children}</LoadingContext.Provider>
  );
};
